import { render } from "./Catalogslist.vue?vue&type=template&id=b37ec9ce"
import script from "./Catalogslist.vue?vue&type=script&lang=js"
export * from "./Catalogslist.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__